import React from "react";
import clsx from "clsx";
import dayjs from "dayjs";

import Button from "components/Button";
import { formatNumber } from "helpers/formatNumber";
import { getClassByStatus } from "helpers/getClassByVariant";
import { useColorScheme } from "hooks/useColorScheme";
import { IFundingRequestItem } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  data?: IFundingRequestItem;
  goToMoreDetails?: VoidFunction;
}

const CarrierFundingRequestItem: React.FC<IProps> = React.memo(
  ({ data, goToMoreDetails }: Readonly<IProps>) => {
    const { currentIsDark } = useColorScheme();
    if (!data) {
      return (
        <div
          className={clsx(
            styles.container,
            !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]"
          )}>
          <p className="text-center text-gray-500">No data available.</p>
        </div>
      );
    }

    return (
      <ul
        className={clsx(styles.container, !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]")}>
        <li className="items-start">
          <span className="font-semibold">Bill To</span>
          <span>{data?.debtor?.name || "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Invoice Amount</span>
          <span>{data ? formatNumber(data.amount, 2) : "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Invoice #</span>
          <span>{data?.invoiceNumber || "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Load #</span>
          <span>{data?.userLoadNumber || "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Requested At</span>
          <span>{data ? dayjs(data.created).format("MM/DD/YYYY hh:mm A") : "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Invoiced At</span>
          <span>
            {data?.invoiceDate ? dayjs(data.invoiceDate).format("MM/DD/YYYY hh:mm A") : "-"}
          </span>
        </li>
        <li>
          <span className="font-semibold">Funded At</span>
          <span>{data?.fundedAt ? dayjs(data.fundedAt).format("MM/DD/YYYY hh:mm A") : "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Rate</span>
          <span>{Number(data.discountRate) ? `${data.discountRate}%` : "-"}</span>
        </li>
        <li>
          <span className="font-semibold">Payment Amount</span>
          <span>{data ? formatNumber(Number(data.amountFunded), 2) : "-"}</span>
        </li>
        <li className="!items-start">
          <span className="font-semibold">Status</span>
          <span className={clsx("uppercase", getClassByStatus(data.status))}>{data.status}</span>
        </li>
        <li>
          <span className="font-semibold">Details</span>
          <Button
            variant="outline"
            className={styles.moreButton}
            rounded
            onClick={goToMoreDetails}
            aria-label={`View more details for invoice ${data?.invoiceNumber}`}>
            More
          </Button>
        </li>
      </ul>
    );
  }
);

CarrierFundingRequestItem.displayName = "CarrierFundingRequestItem";
export default CarrierFundingRequestItem;
